import { packIntoFormData } from "../utilities/apiUtilities";
import axiosInstance from "../auth/axioInstance";

const controllerUrl = `/competition`

function createCompetition(competitionCreateViewModel) {

    // console.log(competitionCreateViewModel)
    // console.log(packIntoFormData(competitionCreateViewModel))

    //return

    return axiosInstance.post(`${controllerUrl}`, packIntoFormData(competitionCreateViewModel), { headers: { 'Content-Type': "multipart/form-data"} });
}

function indexCompetitions({
    sortOrder = "", 
    searchString = "", 
    pageSize = 50, 
    pageNumber = 1
}) {
    return axiosInstance.get(`${controllerUrl}`, { params: {sortOrder: sortOrder, searchString: searchString, pageSize: pageSize, pageNumber: pageNumber}});
}

function getCompetition(id) {
    return axiosInstance.get(`${controllerUrl}/${id}`);
}

function updateCompetition(id, competitionCreateViewModel) {
    return axiosInstance.post(`${controllerUrl}/${id}`, packIntoFormData(competitionCreateViewModel), { headers: { 'Content-Type': "application/json" } });
}

function deleteCompetition(id) {
    return axiosInstance.delete(`${controllerUrl}/${id}`);
}

function updateInputResult(id , horseList){

    // console.log(horseList)
    // return
    return axiosInstance.post(`${controllerUrl}/${id}/updateleaderboardpoints`, packIntoFormData(horseList), { headers: { 'Content-Type': "application/json"} });

}

export const competitionService = {
    createCompetition,
    indexCompetitions,
    getCompetition,
    updateCompetition,
    deleteCompetition,
    updateInputResult
}